module.exports = __webpack_public_path__ + "5da92be758f4ff7ce41d4a4d27b0bab2.pdf";